export default __webpack_public_path__ + "static/media/Community.ba437f77.png";